import React, { useState, useEffect } from "react";
import {
    Row,
    Col,
    Breadcrumb,
    Card,
    CardBody,
    Form,
    CardFooter,
    Table,
    Badge
} from "react-bootstrap";
import { Button } from 'primereact/button';
import axios from 'axios';
import config from '../config';
import { useAuth } from '../context/AuthContext';
import successVideo from '../assets/video/paperplane.mp4';
import crossVideo from '../assets/video/cross.mp4';
import { Dialog } from "primereact/dialog";
import { AutoComplete } from "primereact/autocomplete";
import { Tooltip } from 'primereact/tooltip';
import { Calendar } from 'primereact/calendar';
import { Avatar } from 'primereact/avatar';
import noUserImg from '../assets/images/no_user.png';
const MinutesofMeeting = ({ brandId }) => {
    const { accessToken, role, userId } = useAuth();
    const [minutesOfMeeting, setMinutesOfMeeting] = useState(null);
    const [loading, setLoading] = useState(true);
    const [editDialogVisible, setEditDialogVisible] = useState(false);
    const [videoDialogVisible, setVideoDialogVisible] = useState(false); // New state for video dialog
    const [videocrossDialogVisible, setVideocrossDialogVisible] = useState(false); // New state for video dialog
    const currentDate = new Date();
    const [selectedDate, setSelectedDate] = useState(currentDate);
    const [month, setMonth] = useState(currentDate.getMonth() + 1);
    const [year, setYear] = useState(currentDate.getFullYear());
    const allowedRoles = [
        'Founder', 'Admin', 'SuperAdmin', 'HumanResource',
        'Social_Media_Manager', 'Task_manager'
    ];


    const [formData, setFormData] = useState({
        date: '',
        meeting_type: 'Internal',
        meeting_title: '',
        meeting_members: '',
        agenda: '',
        decisions: '',
        action_items: '',
        discussions: '',
        client_updates: ''
    });
    const [projects, setProjects] = useState([]);
    const [filteredProjects, setFilteredProjects] = useState([]);
    const [selectedProject, setSelectedProject] = useState(null);
    const [isLoading, setIsLoading] = useState(false); // Add loading state


    // Fetch projects with optional brand_id filter
    const fetchProjects = async () => {
        try {
            // Construct the query URL with optional brand_id parameter
            let url = `${config.apiBASEURL}/BrandBookRoutes/fetch-projects`;

            if (brandId) {
                url += `?brand_id=${brandId}`;  // Add brand_id to the query string
            }

            const response = await axios.get(url, {
                headers: { Authorization: `Bearer ${accessToken}` }
            });
            setProjects(response.data.data || []);
        } catch (error) {
            console.error("Error fetching projects:", error);
        }
    };



    useEffect(() => {
        setSelectedProject(null); // Reset project selection when brand changes
        fetchProjects();
    }, [accessToken, brandId]);




    const fetchMinutesOfMeeting = async () => {
        if (!brandId) return;

        try {
            setLoading(true);

            const response = await axios.get(
                `${config.apiBASEURL}/BrandBookRoutes/fetchMinutesOfMeeting/${brandId}`,
                {
                    headers: { Authorization: `Bearer ${accessToken}` },
                    params: { month, year } // Adding month and year filter
                }
            );

            setMinutesOfMeeting(response.data.data);
        } catch (err) {
            console.error("Error fetching minutes of meeting:", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchMinutesOfMeeting();
    }, [brandId, accessToken, month, year]); // Added month and year as dependencies


    const handleEditClick = () => {
        setEditDialogVisible(true);
    };



    if (loading) return <p>Loading...</p>;
    if (!minutesOfMeeting || Object.keys(minutesOfMeeting).length === 0) {
        return <p>No minutes of meeting available.</p>;
    }


    const searchProjects = (event) => {
        const query = event.query.toLowerCase();
        setFilteredProjects(
            projects.filter((project) =>
                project.project_name.toLowerCase().includes(query)
            )
        );
    };


    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!selectedProject) {
            console.error('Project is required.');
            return;
        }

        try {
            const response = await axios.post(`${config.apiBASEURL}/BrandBookRoutes/addMinutesOfMeeting`, {
                ...formData,
                brand_id: brandId,
                project_id: selectedProject.project_id, // Mandatory project_id
                creator_id: userId,
            }, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    'Content-Type': 'application/json'
                }
            });

            if (response.status === 201) {
                setVideoDialogVisible(true);
                setTimeout(() => {
                    setVideoDialogVisible(false);
                    fetchMinutesOfMeeting();
                    resetFormData();
                }, 5000);
            }
        } catch (error) {
            console.error('Error adding meeting minutes:', error);
            setVideocrossDialogVisible(true);
            setTimeout(() => {
                setVideocrossDialogVisible(false);
            }, 5000);
        } finally {
            setIsLoading(false);
            setEditDialogVisible(false);
        }
    };


    const resetFormData = () => {
        setFormData({
            date: '',
            meeting_type: 'Internal',
            meeting_title: '',
            meeting_members: '',
            agenda: '',
            decisions: '',
            action_items: '',
            discussions: '',
            client_updates: ''
        });
        setSelectedProject(null);
    };


    return (
        <>
            <Card className="view-card">
                <Card.Header className="h6 border-0 bg-light d-flex justify-content-between align-items-center">
                    <div>Minutes of Meeting</div>
                    <div className="d-flex align-items-center">
                        <Calendar
                            value={selectedDate}
                            onChange={(e) => {
                                setSelectedDate(e.value);
                                setMonth(e.value ? new Date(e.value).getMonth() + 1 : null);
                                setYear(e.value ? new Date(e.value).getFullYear() : null);
                            }}
                            view="month"
                            dateFormat="mm/yy"
                            style={{ width: '100px' }}
                            className="me-2"
                        />
                        <small className="text-warning ">
                            {allowedRoles.includes(role) && (
                                <Button
                                    label="Add Meeting"
                                    icon="pi pi-plus"
                                    className=" border-0"
                                    text
                                    severity="danger"
                                    onClick={handleEditClick}
                                />
                            )}
                        </small>
                    </div>
                </Card.Header>
                <Card.Body className="p-0 pb-2">
                    <div className="timeline">
                        {Object.entries(minutesOfMeeting).map(([yearMonth, days]) => (
                            <div key={yearMonth}>
                                <div className="timeline-month">
                                    {yearMonth.toUpperCase()}
                                    <span>{Object.keys(days).length} Meetings</span>
                                </div>
                                {Object.entries(days).map(([day, meetings]) => (
                                    <div key={day} className="timeline-section">
                                        <div className="timeline-date">{day}</div>
                                        <div className="row">
                                            {meetings.map((meeting, index) => (
                                                <div key={index} className="col-sm-11 mb-3">
                                                    <div className="timeline-box meet_notul bg-white">
                                                        <Table size="sm" className="mb-0">
                                                            <thead>
                                                                <tr className="table-light">
                                                                    <th colSpan={2}>
                                                                        <small className="text-secondary">Meeting name : </small>{meeting.meeting_title} <br />
                                                                        <Badge className="bg-warning text-black" style={{ letterSpacing: '0.5px' }}>{meeting.meeting_type}</Badge>
                                                                    </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td><small className="d-block text-muted">Project Name</small></td>
                                                                    <td>{meeting.project_name}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td><small className="d-block text-muted">Meeting Members</small></td>
                                                                    <td>{meeting.meeting_members}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td><small className="d-block text-muted">Agenda</small></td>
                                                                    <td>{meeting.agenda}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td><small className="d-block text-muted">Action Items:</small></td>
                                                                    <td>{meeting.action_items}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td><small className="d-block text-muted">Discussions:</small></td>
                                                                    <td>{meeting.discussions}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td><small className="d-block text-muted">Decisions:</small></td>
                                                                    <td>{meeting.decisions}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td><small className="d-block text-muted">Client Updates:</small></td>
                                                                    <td>{meeting.client_updates}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td><small className="d-block text-muted">Added By:</small></td>
                                                                    <td className="d-flex align-items-center"><Avatar
                                                                        image={meeting.creator.image_url || noUserImg}
                                                                        shape="circle"
                                                                        style={{ width: '24px', height: '24px' }}
                                                                        className="me-2"
                                                                    />
                                                                   <small className="text-danger"> {meeting.creator.name}</small></td>
                                                                </tr>
                                                            </tbody>
                                                        </Table>
                                                    </div>
                                                    {/* <div className="timeline-box">
                                                        <div className="box-content">
                                                            <div className="box-item2">
                                                                <small className="d-flex">
                                                                    {meeting.meeting_type} &nbsp; | &nbsp;
                                                                    <small className="text-secondary">14:30 P.M.</small>
                                                                </small>
                                                                <span>{meeting.meeting_title}</span>
                                                            </div>
                                                            <div className="box-item2">
                                                                <small className="d-flex">
                                                                    Meeting Members  &nbsp; | &nbsp; {meeting.meeting_members}
                                                                </small>
                                                                <span><b>Agenda:</b> {meeting.agenda}</span>
                                                                <span><b>Action Items:</b> {meeting.action_items}</span>
                                                                <span><b>Discussions:</b> {meeting.discussions}</span>
                                                                <span><b>Decisions:</b> {meeting.decisions}</span>
                                                                <span><b>Client Updates:</b> {meeting.client_updates}</span>
                                                            </div>
                                                            <div className="box-item2">
                                                                <small>Added By</small>
                                                                <span className="d-flex align-items-center">
                                                                    <Avatar
                                                                        image={meeting.creator.image_url || noUserImg}
                                                                        shape="circle"
                                                                        style={{ width: '24px', height: '24px' }}
                                                                        className="me-2"
                                                                    />
                                                                    {meeting.creator.name}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div> */}
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ))}
                    </div>
                </Card.Body>
            </Card>

            {/* Edit Dialog */}
            <Dialog
                header="Add Minutes of Meeting"
                visible={editDialogVisible}
                style={{ width: '50vw' }}
                onHide={() => setEditDialogVisible(false)}
                footer={
                    <div>
                        <Button
                            label="Cancel"
                            icon="pi pi-times"
                            severity="danger"
                            onClick={() => {
                                setEditDialogVisible(false);
                                resetFormData(); // Reset form when cancel is clicked
                            }}
                            className="p-button-text py-2"
                        />

                        <Button
                            label={isLoading ? 'Saving...' : 'Save'}
                            icon={isLoading ? 'pi pi-spin pi-spinner' : 'pi pi-folder-open'}
                            severity="success"
                            onClick={handleSubmit}
                            disabled={isLoading}
                            autoFocus
                            className="py-2"
                        />
                    </div>
                }
            >
                <Row style={{ height: '70vh', overflowY: 'auto' }}>
                    <Col md={12} lg={12} className="p-0">
                        <Card>
                            <CardBody className="pb-0 ps-3 pe-3 ">
                                <Form>

                                    <Row>
                                        <Col md={6} lg={6} className="mb-3 px-1">
                                            <Form.Label>Meeting Title
                                                <i
                                                    className='pi pi-info-circle text-warning custom-target-icon ms-2'
                                                    data-pr-tooltip="Note: This title will be visible in the minutes of meeting."
                                                    data-pr-position="right"
                                                    data-pr-at="right+5 top"
                                                    data-pr-my="left center-2"
                                                >
                                                </i>
                                                <Tooltip target=".custom-target-icon" />
                                            </Form.Label>
                                            <Form.Control type="text" name="meeting_title" value={formData.meeting_title} onChange={handleChange} required />
                                        </Col>
                                        <Col md={6} lg={6} className="mb-3 px-1">
                                            <Form.Label>Meeting Type
                                                <i
                                                    className='pi pi-info-circle text-warning custom-target-icon ms-2'
                                                    data-pr-tooltip="Note: Nature of the Meeting that has been Completed."
                                                    data-pr-position="right"
                                                    data-pr-at="right+5 top"
                                                    data-pr-my="left center-2"
                                                >
                                                </i>
                                                <Tooltip target=".custom-target-icon" />
                                            </Form.Label>
                                            <Form.Control as="select" name="meeting_type" value={formData.meeting_type} onChange={handleChange}>
                                                <option value="Call">Call</option>
                                                <option value="Video_call">Video Call</option>
                                                <option value="In_person">In Person</option>
                                                <option value="Hybrid">Hybrid</option>
                                                <option value="Internal">Internal</option>
                                                <option value="Client_meeting">Client Meeting</option>
                                                <option value="Presentation">Presentation</option>
                                                <option value="Review">Review</option>
                                                <option value="Training">Training</option>
                                                <option value="Brainstorming">Brainstorming</option>
                                            </Form.Control>
                                        </Col>
                                        <Col md={6} lg={6} className="mb-3 px-1">
                                            <Form.Label>Date
                                                <i
                                                    className='pi pi-info-circle text-warning custom-target-icon ms-2'
                                                    data-pr-tooltip="Note: Date the meeting has been conducted."
                                                    data-pr-position="right"
                                                    data-pr-at="right+5 top"
                                                    data-pr-my="left center-2"
                                                >
                                                </i>
                                                <Tooltip target=".custom-target-icon" />
                                            </Form.Label>
                                            <Form.Control type="date" name="date" value={formData.date} onChange={handleChange} required />
                                        </Col>


                                        



                                        <Col md={6} lg={6} className="mb-3 px-1">
                                            <Form.Label>Project Name
                                                <i
                                                    className='pi pi-info-circle text-warning custom-target-icon ms-2'
                                                    data-pr-tooltip="Note: Add Project required either Seperately or together."
                                                    data-pr-position="right"
                                                    data-pr-at="right+5 top"
                                                    data-pr-my="left center-2"
                                                >
                                                </i>
                                                <Tooltip target=".custom-target-icon" />
                                            </Form.Label>
                                            <AutoComplete
                                                value={selectedProject}
                                                suggestions={filteredProjects}
                                                completeMethod={searchProjects}
                                                field="project_name"
                                                onChange={(e) => setSelectedProject(e.value)}
                                                placeholder="Search Project"
                                                className="w-100"
                                            />
                                        </Col>


                                        <Col md={6} lg={6} className="mb-3 px-1">
                                            <Form.Label>Meeting Members
                                                <i
                                                    className='pi pi-info-circle text-warning custom-target-icon ms-2'
                                                    data-pr-tooltip="Note: Names of Meeting Participants / Attendees (Seperated by Commas)."
                                                    data-pr-position="right"
                                                    data-pr-at="right+5 top"
                                                    data-pr-my="left center-2"
                                                >
                                                </i>
                                                <Tooltip target=".custom-target-icon" />
                                            </Form.Label>
                                            <Form.Control as="textarea" rows={4} name="meeting_members" value={formData.meeting_members} onChange={handleChange} className="h-auto" />
                                        </Col>
                                        <Col md={6} lg={6} className="mb-3 px-1">
                                            <Form.Label>Agenda
                                                <i
                                                    className='pi pi-info-circle text-warning custom-target-icon ms-2'
                                                    data-pr-tooltip="Note: Agenda of the Meeting."
                                                    data-pr-position="right"
                                                    data-pr-at="right+5 top"
                                                    data-pr-my="left center-2"
                                                >
                                                </i>
                                                <Tooltip target=".custom-target-icon" />
                                            </Form.Label>
                                            <Form.Control as="textarea" rows={4} name="agenda" value={formData.agenda} onChange={handleChange} className="h-auto" />
                                        </Col>

                                        <Col md={6} lg={6} className="mb-3 px-1">
                                            <Form.Label>Action Items
                                                <i
                                                    className='pi pi-info-circle text-warning custom-target-icon ms-2'
                                                    data-pr-tooltip="Note: Actions that has been discussed in this Meeting."
                                                    data-pr-position="right"
                                                    data-pr-at="right+5 top"
                                                    data-pr-my="left center-2"
                                                >
                                                </i>
                                                <Tooltip target=".custom-target-icon" />
                                            </Form.Label>
                                            <Form.Control as="textarea" rows={4} name="action_items" value={formData.action_items} onChange={handleChange} className="h-auto" />
                                        </Col>
                                        <Col md={6} lg={6} className="mb-3 px-1">
                                            <Form.Label>Discussions
                                                <i
                                                    className='pi pi-info-circle text-warning custom-target-icon ms-2'
                                                    data-pr-tooltip="Note: Elaborate discussions that has been discussed in this Meeting."
                                                    data-pr-position="right"
                                                    data-pr-at="right+5 top"
                                                    data-pr-my="left center-2"
                                                >
                                                </i>
                                                <Tooltip target=".custom-target-icon" />
                                            </Form.Label>
                                            <Form.Control as="textarea" rows={4} name="discussions" value={formData.discussions} onChange={handleChange} className="h-auto" />
                                        </Col>
                                        <Col md={6} lg={6} className="mb-3 px-1">
                                            <Form.Label>Decisions
                                                <i
                                                    className='pi pi-info-circle text-warning custom-target-icon ms-2'
                                                    data-pr-tooltip="Note: Decisions that has been discussed in this Meeting."
                                                    data-pr-position="right"
                                                    data-pr-at="right+5 top"
                                                    data-pr-my="left center-2"
                                                >
                                                </i>
                                                <Tooltip target=".custom-target-icon" />
                                            </Form.Label>
                                            <Form.Control as="textarea" rows={4} name="decisions" value={formData.decisions} onChange={handleChange} className="h-auto" />
                                        </Col>
                                        <Col md={6} lg={6} className="mb-3 px-1">
                                            <Form.Label>Client Updates
                                                <i
                                                    className='pi pi-info-circle text-warning custom-target-icon ms-2'
                                                    data-pr-tooltip="Note: Updates from Clients regarding the Meeting (if any)."
                                                    data-pr-position="right"
                                                    data-pr-at="right+5 top"
                                                    data-pr-my="left center-2"
                                                >
                                                </i>
                                                <Tooltip target=".custom-target-icon" />
                                            </Form.Label>
                                            <Form.Control as="textarea" rows={4} name="client_updates" value={formData.client_updates} onChange={handleChange} className="h-auto" />
                                        </Col>
                                    </Row>
                                </Form>
                            </CardBody>
                        </Card>

                    </Col>
                </Row>
            </Dialog>

            <Dialog visible={videoDialogVisible} className='fadeInUp_dilog'
                onHide={() => setVideoDialogVisible(false)} style={{ width: '320px' }} closable={false}>
                <video src={successVideo} autoPlay loop muted style={{ width: '100%' }} />
                <h6 className="text-center mt-0 fadeInUp">Process Completed <span className='text-success'>Successfully</span></h6>
            </Dialog>


            <Dialog visible={videocrossDialogVisible} className='fadeInUp_dilog'
                onHide={() => setVideocrossDialogVisible(false)} style={{ width: '320px' }} closable={false}>
                <video src={crossVideo} autoPlay loop muted style={{ width: '100%' }} />
                <h6 className="text-center mt-0 fadeInUp">Process <span className='text-danger'>Denied</span></h6>
            </Dialog>

        </>
    );
};

export default MinutesofMeeting
